import { render, staticRenderFns } from "./MsMessageBox.vue?vue&type=template&id=50645cac&scoped=true"
import script from "./MsMessageBox.vue?vue&type=script&lang=js"
export * from "./MsMessageBox.vue?vue&type=script&lang=js"
import style0 from "./MsMessageBox.vue?vue&type=style&index=0&id=50645cac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50645cac",
  null
  
)

export default component.exports